import React from "react";
import { classNames } from "../../../shared/utility";
import { InputNumber } from "primereact/inputnumber";
import RequiredFieldLabel from "../RequiredFieldLabel";

export default function DollarInputText(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    suffix,
    explanation,
    ref,
    labelClass,
    required = false,
    ...other
  } = props;

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <div className="space-x-2 mb-1">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-gray-900"
            )}
          >
            <RequiredFieldLabel required={required}>
              {label}
            </RequiredFieldLabel>
          </label>
        </div>
      ) : null}
      <div>
        <InputNumber
          value={value}
          onValueChange={onChange}
          mode="currency"
          currency="USD"
          locale="en-US"
          onKeyDown={(e) => e.stopPropagation()}
          ref={ref}
          suffix={suffix}
          required={required}
          aria-required={required}
          {...other}
        />

        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
